import { createGlobalState } from 'react-use';

export const useTokenRefreshTrigger = createGlobalState(0);
